var map = {
	"./bd-active.webp": "ZMfR",
	"./im-active.webp": "fjsR",
	"./sb-active.webp": "spKp",
	"./ss-active.webp": "4Fdi"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "GRbQ";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/sport ^\.\/.*\-active\.webp$
// module id = GRbQ
// module chunks = 3